import { createApi } from "./common";

export const getPrice = createApi("GET", "prices/");

export default getPrice;
